export enum SELECT_TYPE {
    SELECT = 'select',
    SELECT_SUGGEST = 'select_suggest',
}
